import Confirmation from './Confirmation';

const rmaModals = {
  Confirmation,
}

export default rmaModals;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/rma/index.js